import "./SelectDropdown.css";
import { useEffect, useRef, useState } from "react";
import { Menu } from "@headlessui/react";
import { Trans, t, select } from "@lingui/macro";
import { shortenAddress, useENS } from "lib/legacy";
import { useCopyToClipboard, createBreakpoint } from "react-use";
import externalLink from "img/ic_new_link_16.svg";
import copy from "img/ic_copy_16.svg";
import disconnect from "img/ic_sign_out_16.svg";
// import { FaChevronDown } from "react-icons/fa";
import Davatar from "@davatar/react";
import { helperToast } from "lib/helperToast";
import connectWalletImg from "img/ic_wallet_25.svg";
import FaChevronDown from "img/FaChevronDown.svg";
import Arrow from "img/arrow.png";
function SelectDropdown (props) {
  const { data, selectToken, currentPlatform, setcurrentPlatform } = props;
  const useBreakpoint = createBreakpoint({ L: 600, M: 550, S: 400 });
  const breakpoint = useBreakpoint();
  // const [currentPlatform, setcurrentPlatform] = useState('Ethereum')
  // const { ensName } = useENS(account);
  // const data = ['Ethereum', 'Fantom', 'Polygon', 'Arbitrum']
  const selectType = (token) => {
    setcurrentPlatform(token)
  }
  const newData = data.filter((item) => {
    if (item != currentPlatform) {
      return item
    }
  })
  return (
    <Menu>
      <Menu.Button as="div">
        <button className="select-btn">
          <div className="select-type">
            <div className="current-platform">
              {currentPlatform}
            </div>
            <img src={Arrow} alt="" className="arrow" />
          </div>
        </button>
      </Menu.Button>
      {newData.length >= 1 && <div className="menu-box">
        <Menu.Items as="div" className="menu-items boder-color">
          {
            newData.map((token, index) => {
              return (
                <Menu.Item key={index}>
                  <div className="menu-item menu-style" key={index} onClick={() => { selectType(token) }}>
                    <p>
                      {token}
                      {/* <Trans>content</Trans> */}
                    </p>
                    {/* {item === currentPlatform ? < img src={Arrow} alt="" className="arrow" /> : ""} */}
                  </div>
                </Menu.Item>
              )
            })}
        </Menu.Items>
      </div>}

    </Menu>
  );
}

export default SelectDropdown;
